import styled from 'styled-components';
import { theme } from '../../../../../global';

export const JudgesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacings.s16};
`;

export const JudgeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacings.s8};
`;

export const JudgesName = styled.span`
  font-family: 'Montserrat';
  font-size: 14px;
  font-weight: 600;
  color: ${theme.colors.secondaryText};
`;

export const JudgeTitle = styled.span`
  font-family: 'Montserrat';
  font-size: 12px;
  font-weight: 600;
  color: ${theme.colors.secondaryText};
`;

export const JudgeItem = styled.div`
  display: flex;
  gap: ${theme.spacings.s8};
  align-items: center;
`;

export const Name = styled.span`
  font-family: 'Montserrat';
  font-size: 14px;
  font-weight: 500;
`;
